<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-toolbar-title>New booking: Admin</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
          <div style="display:flex; align-items: center;" >
            <div class="accepted-wrapper">
              <v-menu >
                <template v-slot:activator="{ on }">
                <v-btn text icon v-on="on" class="status" :class="'accepted-' + accepted">
                  <v-icon v-if="accepted === 1" color="grey">device_unknown</v-icon>
                  <v-icon v-else-if="accepted === 2" color="green">mobile_friendly</v-icon>
                  <v-icon v-else-if="accepted === 3" color="primary">phonelink_erase</v-icon>
                  <v-icon v-else color="gray">check</v-icon>
                </v-btn>
                </template>
                <v-list>
                  <v-list-item-group v-model="accepted" @change="changeAccepted(accepted)">
                  <v-list-item v-for="state in acceptedList" :key="state.value" :value="state.value">
                    <v-list-item-title :class="{ 'primary--text': accepted === state.value }">{{ state.text }}</v-list-item-title>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>

            </div>
            <span class="grey--text ml-2">{{ acceptedList[accepted] && acceptedList[accepted].text}}</span>
            <v-spacer/>


          </div>

            <v-layout wrap>
              <v-flex xs12 sm4>
                <v-autocomplete
                  v-bind:items="drivers"
                  v-model="driverObj"
                  label="Drivers"
                  prepend-icon="directions_car"
                  single-line
                  menu-props="bottom"
                  return-object
                  @change = "onChange"
                  autocomplete
                  :rules="itemRules"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm4>
                <v-autocomplete
                  v-bind:items="clients"
                  v-model="clientObj"
                  label="Clients"
                  prepend-icon="accessibility"
                  single-line
                  menu-props="bottom"
                  return-object
                  @change = "onChange"
                  autocomplete
                  :rules="itemRules"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm4>
                <v-autocomplete
                  v-bind:items="destinations"
                  v-model="destinationObj"
                  label="Destination"
                  prepend-icon="location_city"
                  single-line
                  menu-props="bottom"
                  return-object
                  @change = "onChange"
                  autocomplete
                  :rules="itemRules"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <g-input
                  prepend-icon="pin_drop"
                  :required="true"
                  id="pickup_add"
                  ref="pickupAddressAdd"
                  @change="setAddress"
                  @placechanged="setPickup"
                  :label="'Pickup Address'"
                  :delete="true"
                  :rules="itemRules"
                  :error="pickadress_notValid"
                ></g-input>
                <span v-if="pickadress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs12>
                <m-distance-detail v-if="distance_result && bookingType" :booking="distance_result" :type="bookingType"></m-distance-detail>
              </v-flex>
              <v-flex xs6 sm4>
                    <v-select
                      v-bind:items="types"
                      v-model="bookingType"
                      label="Type"
                      menu-props="bottom"
                      :rules="itemRules"
                      required
                      prepend-icon="low_priority"
                      @change="typeChange"
                    ></v-select>
              </v-flex>
               <v-flex d-flex xs6 sm4>
                <v-checkbox class="mt-3" @change="toggleBack"
                :disabled="bookingType!=='to'"
                color="primary"
                  label="Retour?"
                  v-model="form.back"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm4>
                  <v-select
                    v-bind:items="motives"
                    v-model="form.fields.motive"
                    label="Motive"
                    menu-props="bottom"
                  ></v-select>
              </v-flex>

              <v-flex xs12 sm4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_time"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    label="Time"
                    v-model="form.fields.ap_time"
                    prepend-icon="access_time"
                    readonly
                    :rules="itemRules"
                    required
                  ></v-text-field>
                </template>
                  <v-time-picker v-model="form.fields.ap_time"
                  color="primary"
                  format="24hr"
                  autosave
                  @change="menu_time=false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm7>
                    <v-menu
                      ref="datesMenu"
                      v-model="menu_dates"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-combobox
                          color="primary"
                          v-model="form.dates"
                          multiple
                          chips
                          small-chips
                          label="Date(s)"
                          prepend-icon="event"
                          v-on="on"
                          :rules="datesRules"
                          required
                        >
                        <template slot="selection" slot-scope="data" >
                          <v-chip
                            close
                            color="secundary" text-color="black"
                            :input-value="data.selected"
                            small
                            @click:close="removeDate(data.item)"
                          >
                            {{ formatDate(data.item) }}
                          </v-chip>
                        </template>
                        </v-combobox>
                      </template>
                      <v-date-picker v-model="form.dates" multiple no-title scrollable

                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu_dates = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.datesMenu.save(form.dates)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
              <v-flex xs3 :class="{'hide' : hideWait}" >
                  <v-select
                    v-bind:items="waits"
                    v-model="waittime"
                    label="Wait time"
                    menu-props="bottom"
                    @change="calcWaitPrice"
                    prepend-icon="add_alarm"
                  ></v-select>
              </v-flex>
              <v-flex xs2 :class="{'hide' : hideWait}" >
                <div class="mt-3 pa-2 text-xs-left"><span class="subheading">{{ waitprice | currency}}</span></div>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Ticket price"
                  v-model="form.fields.ticket_price"
                  prepend-icon="euro_symbol"
                  :rules="currencyRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12><hr class="dotted"></v-flex>
              <v-flex xs12 sm4 >

              <v-checkbox class="mt-3"
                color="primary"
                label="Factuur client?"
                v-model="factuur"
                @change="form.fields.factuur = factuur"
              ></v-checkbox>
              </v-flex>



              <v-flex xs12 sm4 :class="{'hide' : !factuur}">
                <v-text-field
                  label="Factuur price"
                  v-model="form.fields.price"
                  prepend-icon="euro_symbol"
                  :disabled="!factuur"
                  :rules="currencyRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <div v-if="basePrice" class="text-right">({{ basePrice | currency }})</div>
              </v-flex>
              <v-flex xs12><hr class="dotted"></v-flex>
               <v-flex xs12 sm4>
                 <div class="invoice-label">Driver:</div>
                <v-text-field
                  label="Price"
                  v-model="form.fields.price_driver"
                  prepend-icon="euro_symbol"
                  :rules="currencyRules"
                  @change="changePrice"
                ></v-text-field>

              </v-flex>
              <v-divider inset vertical class="pl-3"></v-divider>
              <v-flex xs12 sm6 class="pl-3">
                <div class="invoice-label">
                <v-checkbox class="mt-3"
                  color="primary"
                  label="Factuur driver?"
                  v-model="factuurDriver"
                  @change="form.fields.factuurDriver = factuurDriver"
                ></v-checkbox>
                <v-checkbox class="mt-3"
                  color="primary"
                  label="Credit driver?"
                  v-model="creditDriver"
                  @change="form.fields.creditDriver = creditDriver"
                ></v-checkbox>

                </div>
                <div class="ml-3 mb-2 invoiceAddress" :class="{'hide' : !creditDriver}">
                  <v-text-field
                    label="Credit"
                    v-model="form.fields.creditAmount"
                    prepend-icon="euro_symbol"
                    @change="changePrice"
                    :rules="currencyRules"
                  ></v-text-field>
                  <v-text-field
                    label="Reason"
                    v-model="form.fields.creditReason"
                    prepend-icon="chat"
                    @change="changePrice"
                  ></v-text-field>
                </div>
              </v-flex>








              <v-flex xs12><hr class="dotted"></v-flex>

              <v-flex xs12 sm3 >
              <v-checkbox class="mt-3" @change="toggleMutual"
              color="primary"
                label="Insurance?"
                v-model="mutual"
              ></v-checkbox>
              </v-flex>

              <v-flex xs12 v-if="mutual">
                <v-layout wrap class="invoiceAddress">
                  <v-flex xs12>
                    <div class="invoice-label">Mutual:</div>
                  </v-flex>

                  <v-flex xs12 sm4>
                        <v-autocomplete
                          v-bind:items="insurances"
                          v-model="insuranceObj"
                          label="Insurance"
                          prepend-icon="location_city"
                          single-line
                          menu-props="bottom"
                          return-object
                          @change = "onChangeInsurance"
                          autocomplete
                          :rules="itemRules"
                          required
                        ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm2 ></v-flex>
                  <v-flex xs12 sm6 class="text-right">
                    <div class="" v-if="form.fields.certificateNeeded">Certificat est requis <v-icon color="primary">receipt</v-icon> </div>
                    <div v-if="nonReimbursed.monthlyBudget">Budget par mois: <span class="primary--text">{{ nonReimbursed.monthlyBudget | currency}}</span></div>
                    <div v-if="nonReimbursed.perDay">Par jour: <span class="primary--text">{{ nonReimbursed.perDay | currency}}</span></div>
                    <div v-if="nonReimbursed.perPart">Par traject: <span class="primary--text">{{ nonReimbursed.perPart | currency}}</span></div>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="form.fields.mutualPatientID" :rules="itemRules" required label="Trip ID"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field prepend-icon="place" v-model="form.fields.mutualDistance" label="Distance"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field prepend-icon="euro_symbol" v-model="form.fields.mutualAmount" :rules="currencyRules" label="Price fix"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field prepend-icon="euro_symbol" v-model="form.fields.mutualPatientAmount" :rules="currencyRules" label="Price patient"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                  <span class="primary--text" v-if="form.fields.noMutIntervention"><v-icon small color="primary">warning</v-icon>  Pas intervention Mutuelle </span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="form.fields.mutualComment" label="Comment"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12><hr class="dotted"></v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Comment"
                  v-model="form.fields.comment"
                  prepend-icon="chat"
                  multi-line
                ></v-textarea>
              </v-flex>
            </v-layout>
        </v-container>
        <small>*indicates required field</small>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment';
  import recur from 'moment-recur';
  import BookingFormMixin from '@/mixins/booking-form'
  import NotifyMixin from '@/mixins/notification'

  export default {
    mixins: [BookingFormMixin, NotifyMixin],
    data () {
      return {
        date: null,
        dates: [],
        menu_dates: false
      }
    },
    methods: {
      removeDate (item) {
        this.form.dates.splice(this.form.dates.indexOf(item), 1)
        this.form.dates = [...this.form.dates];
      },

      init (v) {
        if (v) {
          console.log('Add admin: do init:', this.booking);
          this.reset();
          this.resetMutual();
          this.prefill(this.booking);
          // this.test('01/01/2014', '01/30/2014');
        }
      },
      test (start, end, every) {
        var recurrence = moment().recur(start, end).every(every).days();
        // Outputs: ["01/01/2014", "01/03/2014", "01/05/2014", "01/07/2014"]
        if (recur) {
          console.log(recurrence.all('L'));
        }
        return recurrence.all('L');
      }
    }
  }
</script>

